exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._91O5hye2I-TfAqRyQLwQo{display:block;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:14px;font-weight:400;color:\"[theme:neutralPrimary, default:#323130]\"}html[dir=ltr] ._91O5hye2I-TfAqRyQLwQo{padding:9px 24px 24px 15px}html[dir=rtl] ._91O5hye2I-TfAqRyQLwQo{padding:9px 15px 24px 24px}", ""]);
// Exports
exports.locals = {
	"headerFooterContainer": "_91O5hye2I-TfAqRyQLwQo"
};